import { jsx } from "react/jsx-runtime";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import { validateTidalLicense } from "../../base/index.js";
function FormatListBulleted(props) {
  return /* @__PURE__ */ jsx(
    FormatListBulletedIcon,
    {
      "data-testid": "FormatListBulleted",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "FormatListBulleted",
      "data-tidal-icon-meta": "editing,attachment"
    }
  );
}
FormatListBulleted.tidalIconMeta = {
  categories: "editing,attachment",
  name: "FormatListBulleted"
};
validateTidalLicense();
export {
  FormatListBulleted
};
//# sourceMappingURL=FormatListBulleted.js.map
